module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1096.82f51a4b.png";